<template>
	<div class="bg-gray-50">
		<DefaultSection>
			<BrowseCarsForSubscription />
		</DefaultSection>

		<DefaultSection
			v-if="
				hasActivePrimaryCampaigns &&
				!isListingOnly &&
				isGroupSubscriptionEnabled
			"
		>
			<GroupSubsBanner />
		</DefaultSection>

		<ContainedSection :has-padding="false">
			<TwoColumns
				first-column-width="w-full lg:w-1/3"
				second-column-width="w-full lg:w-2/3"
				first-column-class="rounded bg-white"
				second-column-class="rounded bg-white"
				column-gap="gap-6"
			>
				<template #first>
					<BusinessCards />
				</template>
				<template #second>
					<AllInclusiveSubscriptionServer />
				</template>
			</TwoColumns>
		</ContainedSection>

		<ContainedSection :has-padding="false">
			<TwoColumns
				second-column-width="w-full lg:w-1/3"
				first-column-width="w-full lg:w-2/3"
				first-column-class="bg-white "
				second-column-class=""
				column-gap="gap-6"
			>
				<template #first>
					<SellingOrUpgradingCar
						heading="Sell my car"
						:has-contained-within="true"
					/>
				</template>
				<template #second>
					<IdriveRentalsCard />
				</template>
			</TwoColumns>
		</ContainedSection>

		<ContainedSection
			:has-background="true"
			:has-padding="false"
			background-color="bg-white"
			custom-class="text-center contained-section"
		>
			<Elfsight />
		</ContainedSection>

		<ContainedSection :has-padding="false" :has-background="true">
			<StartSubscriptionJourney
				image="img/home/img-start_a_journey.webp"
			/>
		</ContainedSection>

		<ContainedSection>
			<h2 class="xl:text-2xl">Search by popular makes or models</h2>
			<SectionsListPopularBrandsAndModels class="mt-8" />
		</ContainedSection>
	</div>
</template>

<script setup>
import GroupSubsBanner from '@/components/campaigns/banners/2026/GroupSubsBanner.vue'
import Elfsight from '@/components/elfsight/Elfsight.vue'
import AllInclusiveSubscriptionServer from '@/components/home/AllInclusiveSubscription.server.vue'
import BrowseCarsForSubscription from '@/components/home/BrowseCarsForSubscription.vue'
import BusinessCards from '@/components/home/cards/BusinessCard.vue'
import IdriveRentalsCard from '@/components/home/cards/IdriveRentalsCard.vue'
import SellingOrUpgradingCar from '@/components/home/SellingOrUpgradingCar.vue'
import ContainedSection from '@/components/sections/ContainedSection.vue'
import DefaultSection from '@/components/sections/DefaultSection.vue'
import StartSubscriptionJourney from '@/components/sections/StartSubscriptionJourney.vue'
import TwoColumns from '@/components/sections/TwoColumns.vue'
import { useCampaignsStore } from '@/stores/campaigns'

const campaignsStore = useCampaignsStore()
const isListingOnly = useIsListingOnly()
const isGroupSubscriptionEnabled = useIsGroupSubscriptionEnabled()

const hasActivePrimaryCampaigns = computed(
	() =>
		campaignsStore.hasAnyCampaignsActive &&
		!!campaignsStore.getPrimaryCampaignKey
)
</script>
